import type { PrioritizationResult } from '@core-api/presentation/types/response';
import { useFetchHundredPointsResults } from '@mentimeter/presentation-data-hooks/fetch-hundred-points-results';

interface UseHundredPointsResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useHundredPointsResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseHundredPointsResultsParams): {
  results: PrioritizationResult[];
  isLoading: boolean;
} => {
  const { data, isLoading } = useFetchHundredPointsResults({
    adminKey,
    interactiveContentId,
    shouldFetchResults,
    sessionId,
  });

  return {
    results: data?.results ?? [],
    isLoading,
  };
};
